// AccountCSS.js — inject once at the top-level Account component
export const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Fira+Code:wght@500;600&display=swap');

.ap-root *, .ap-root *::before, .ap-root *::after { box-sizing: border-box; margin:0; padding:0; }
.ap-root { font-family:'Plus Jakarta Sans',sans-serif; }

/* ════ DASHBOARD ════ */
.ap-dash {
  display: grid;
  grid-template-columns: 240px 1fr;
  min-height: 100vh;
  background: #f3faf2;
}

/* Sidebar */
.ap-side {
  background: #fff;
  border-right: 1px solid #eaecf0;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}
.ap-side-brand {
  padding: 24px 20px 20px;
  border-bottom: 1px solid #f0f1f3;
  display: flex;
  align-items: center;
  gap: 10px;
}
.ap-side-brand-icon {
  width: 34px; height: 34px;
  background: #111827;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 15px;
}
.ap-side-brand-name { font-size: 15px; font-weight: 700; color: #111827; letter-spacing: -.3px; }

.ap-side-nav { flex:1; padding: 16px 12px; }
.ap-side-nav-label {
  font-size: 10px; font-weight: 700; color: #9ca3af;
  letter-spacing: 1px; text-transform: uppercase;
  padding: 0 8px; margin: 16px 0 6px;
}
.ap-side-nav-label:first-child { margin-top: 0; }

.ap-nav-link {
  display: flex; align-items: center; justify-content: space-between;
  gap: 8px; padding: 9px 10px; border-radius: 8px;
  font-size: 13.5px; font-weight: 500; color: #6b7280;
  text-decoration: none; transition: all .15s;
  margin-bottom: 1px; cursor: pointer;
  background: none; border: none; width: 100%; text-align: left;
}
.ap-nav-link:hover { background: #f9fafb; color: #111827; }
.ap-nav-link.active { background: #f0fdf4; color: #15803d; font-weight: 600; }
.ap-nav-link-left { display:flex; align-items:center; gap:9px; }
.ap-nav-count {
  font-size: 10px; font-weight: 700; font-family: 'Fira Code', monospace;
  background: #dcfce7; color: #15803d;
  padding: 2px 7px; border-radius: 20px;
}
.ap-side-divider { height:1px; background:#f0f1f3; margin: 8px 0; }

/* Sidebar user card */
.ap-side-user {
  margin: 12px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex; align-items: center; gap: 10px;
}
.ap-avatar {
  width: 36px; height: 36px; border-radius: 9px;
  background: linear-gradient(135deg, #111827, #374151);
  display: flex; align-items: center; justify-content: center;
  font-size: 13px; font-weight: 700; color: #fff;
  font-family: 'Fira Code', monospace;
  flex-shrink: 0;
}
.ap-user-name { font-size: 13px; font-weight: 600; color: #111827; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.ap-user-email { font-size: 11px; color: #9ca3af; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.ap-logout-ico {
  margin-left: auto; flex-shrink:0;
  background: none; border: none; cursor: pointer;
  color: #d1d5db; padding: 4px; border-radius: 6px;
  transition: color .15s, background .15s; font-size: 15px;
}
.ap-logout-ico:hover { color: #ef4444; background: #fef2f2; }

/* Main area */
.ap-main { display:flex; flex-direction:column; min-height:100vh; }

.ap-topbar {
  height: 58px;
  background: #fff;
  border-bottom: 1px solid #eaecf0;
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 28px;
  position: sticky; top: 0; z-index: 1;
}
.ap-topbar-title { font-size: 14px; font-weight: 600; color: #111827; }
.ap-topbar-right { display:flex; align-items:center; gap:8px; }
.ap-btn-sm {
  display: flex; align-items: center; gap: 5px;
  padding: 7px 13px; border-radius: 7px;
  font-size: 12px; font-weight: 600;
  font-family: 'Plus Jakarta Sans', sans-serif;
  cursor: pointer; border: none; transition: all .15s;
}
.ap-btn-sm.outline {
  background: #fff; color: #374151;
  border: 1px solid #e5e7eb;
}
.ap-btn-sm.outline:hover { background: #f9fafb; border-color: #d1d5db; }
.ap-btn-sm.outline:disabled { opacity:.5; cursor:default; }
.ap-btn-sm.danger { background:#fff; color:#dc2626; border:1px solid #fca5a5; }
.ap-btn-sm.danger:hover { background:#fef2f2; }
.ap-btn-sm.primary { background:#111827; color:#fff; border:1px solid #111827; }
.ap-btn-sm.primary:hover { background:#1f2937; }

.ap-body { padding: 28px; flex:1; }

/* Alert */
.ap-alert {
  border-radius: 9px; padding: 11px 15px;
  font-size: 13px; font-weight: 500; margin-bottom: 20px;
  display: flex; align-items: center; gap: 8px;
}
.ap-alert.ok  { background:#f0fdf4; color:#15803d; border:1px solid #bbf7d0; }
.ap-alert.err { background:#fef2f2; color:#dc2626; border:1px solid #fca5a5; }

/* Welcome banner */
.ap-welcome {
  background: #111827;
  border-radius: 14px;
  padding: 28px 32px;
  margin-bottom: 24px;
  display: flex; align-items: center; justify-content: space-between;
  position: relative; overflow: hidden;
}
.ap-welcome::before {
  content:'';
  position:absolute; top:-40px; right:-40px;
  width:180px; height:180px; border-radius:50%;
  background: rgba(255,255,255,0.03);
}
.ap-welcome::after {
  content:'';
  position:absolute; bottom:-60px; right:80px;
  width:140px; height:140px; border-radius:50%;
  background: rgba(255,255,255,0.03);
}
.ap-welcome-text {
  position: relative;
  z-index: 1;
  min-width: 0;
  flex: 1 1 auto;
}
.ap-welcome-greeting { font-size: 11px; font-weight: 600; color: #6b7280; letter-spacing:.8px; text-transform:uppercase; margin-bottom:6px; }
.ap-welcome-name { font-size: 22px; font-weight: 800; color: #fff; letter-spacing:-.5px; margin-bottom:4px; }
.ap-welcome-sub { font-size: 13px; color: #6b7280; }
.ap-welcome-badge {
  position: relative;
  z-index: 1;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 45%;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 12px;
  padding: clamp(10px, 2.4vw, 16px) clamp(12px, 3vw, 20px);
  text-align: center;
}
.ap-welcome-badge-val {
  font-size: clamp(14px, 3.4vw, 22px);
  font-weight: 800;
  color: #fff;
  font-family: 'Fira Code', monospace;
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ap-welcome-badge-lbl {
  font-size: clamp(9px, 2.2vw, 11px);
  color: #9ca3af;
  margin-top: 4px;
  white-space: nowrap;
}

/* Stat cards */
.ap-stats { display:grid; grid-template-columns:repeat(3,1fr); gap:14px; margin-bottom:24px; }
.ap-stat {
  background: #fff; border: 1px solid #eaecf0; border-radius: 12px;
  padding: 20px; display:flex; align-items:center; gap:14px;
  transition: box-shadow .2s;
}
.ap-stat:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.06); }
.ap-stat-icon {
  width: 42px; height: 42px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; flex-shrink:0;
}
.ap-stat-icon.g { background:#f0fdf4; color:#16a34a; }
.ap-stat-icon.b { background:#eff6ff; color:#2563eb; }
.ap-stat-icon.a { background:#fffbeb; color:#d97706; }
.ap-stat-val { font-size: 22px; font-weight: 800; color:#111827; font-family:'Fira Code',monospace; line-height:1; margin-bottom:2px; }
.ap-stat-lbl { font-size: 12px; color: #9ca3af; font-weight:500; }

/* Section */
.ap-section { background:#fff; border:1px solid #eaecf0; border-radius:12px; margin-bottom:20px; overflow:hidden; }
.ap-section-hd {
  padding: 16px 22px;
  border-bottom: 1px solid #f3f4f6;
  display: flex; align-items:center; justify-content:space-between;
}
.ap-section-title { font-size:13px; font-weight:700; color:#111827; }
.ap-section-sub { font-size:11px; color:#9ca3af; margin-top:1px; }
.ap-section-bd { padding: 22px; }
.ap-section-link { font-size:12px; font-weight:600; color:#15803d; text-decoration:none; }
.ap-section-link:hover { text-decoration:underline; }

/* Profile grid */
.ap-profile-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(160px,1fr)); gap:20px; }
.ap-field-lbl { font-size:10px; font-weight:700; color:#9ca3af; text-transform:uppercase; letter-spacing:.7px; margin-bottom:5px; }
.ap-field-val { font-size:14px; font-weight:600; color:#111827; }
.ap-field-val.mono { font-family:'Fira Code',monospace; font-size:12.5px; color:#15803d; }
.ap-status-dot { display:inline-flex; align-items:center; gap:6px; font-size:13px; font-weight:600; color:#16a34a; }
.ap-status-dot::before { content:''; width:7px; height:7px; border-radius:50%; background:#16a34a; display:inline-block; }

/* Actions */
.ap-actions { display:grid; grid-template-columns:repeat(auto-fill,minmax(190px,1fr)); gap:10px; }
.ap-action {
  display:flex; align-items:center; gap:12px;
  padding:14px 16px; border-radius:10px;
  border: 1px solid #eaecf0; text-decoration:none;
  color:#374151; transition:all .15s; background:#fff;
}
.ap-action:hover { border-color:#bbf7d0; background:#f0fdf4; }
.ap-action-ico {
  width:34px; height:34px; border-radius:8px;
  display:flex; align-items:center; justify-content:center;
  font-size:15px; flex-shrink:0;
}
.ap-action-ico.g { background:#f0fdf4; color:#16a34a; }
.ap-action-ico.b { background:#eff6ff; color:#2563eb; }
.ap-action-ico.a { background:#fffbeb; color:#d97706; }
.ap-action-ico.r { background:#fef2f2; color:#dc2626; }
.ap-action-name { font-size:13px; font-weight:600; color:#111827; display:block; }
.ap-action-sub  { font-size:11px; color:#9ca3af; }
.ap-action-badge {
  margin-left:auto; flex-shrink:0;
  background:#111827; color:#fff;
  font-size:10px; font-weight:700; font-family:'Fira Code',monospace;
  padding:2px 8px; border-radius:20px;
}

/* Spinner */
.ap-spinner { text-align:center; padding:48px; color:#9ca3af; font-size:13px; }
.ap-spin-ring {
  width:30px; height:30px; border-radius:50%;
  border:2px solid #e5e7eb; border-top-color:#111827;
  animation:ap-spin .7s linear infinite;
  margin:0 auto 12px;
}
@keyframes ap-spin { to{ transform:rotate(360deg); } }

/* ════ SETTINGS ════ */
.ap-settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
.ap-settings-form-field { margin-bottom: 16px; }
.ap-settings-label {
  display: block;
  font-size: 12px; font-weight: 600; color: #374151;
  margin-bottom: 6px;
}
.ap-settings-input {
  width: 100%; padding: 11px 14px;
  font-size: 14px; font-family: 'Plus Jakarta Sans', sans-serif;
  background: #fff; border: 1.5px solid #e5e7eb;
  border-radius: 9px; color: #111827; outline: none;
  transition: border-color .18s;
}
.ap-settings-input:focus { border-color: #111827; background: #fafafa; }
.ap-settings-input::placeholder { color: #d1d5db; }
.ap-settings-input:disabled {
  background: #f9fafb; color: #9ca3af;
  cursor: not-allowed; border-color: #f3f4f6;
}
.ap-settings-input-wrap { position: relative; }
.ap-settings-input-wrap .ap-settings-input { padding-right: 42px; }
.ap-settings-eye {
  position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
  background: none; border: none; cursor: pointer;
  color: #9ca3af; font-size: 16px; padding: 0;
}
.ap-settings-eye:hover { color: #374151; }
.ap-settings-hint {
  font-size: 11px; color: #9ca3af; margin-top: 5px;
  display: flex; align-items: center; gap: 4px;
}
.ap-settings-hint.locked { color: #f59e0b; }
.ap-settings-divider { height:1px; background:#f3f4f6; margin: 20px 0; }
.ap-settings-save-row {
  display: flex; align-items: center; justify-content: flex-end; gap: 10px;
  padding-top: 4px;
}
.ap-settings-save-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 10px 20px; border-radius: 9px;
  font-size: 13px; font-weight: 700;
  font-family: 'Plus Jakarta Sans', sans-serif;
  background: #111827; color: #fff;
  border: none; cursor: pointer; transition: all .15s;
}
.ap-settings-save-btn:hover:not(:disabled) { background: #1f2937; transform: translateY(-1px); }
.ap-settings-save-btn:disabled { opacity: .45; cursor: default; transform: none; }
.ap-settings-cancel-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 10px 18px; border-radius: 9px;
  font-size: 13px; font-weight: 600;
  font-family: 'Plus Jakarta Sans', sans-serif;
  background: #f9fafb; color: #374151;
  border: 1.5px solid #e5e7eb; cursor: pointer; transition: all .15s;
}
.ap-settings-cancel-btn:hover:not(:disabled) { background: #f3f4f6; }
.ap-settings-cancel-btn:disabled { opacity: .45; cursor: default; }
.ap-password-section {
  background: #f9fafb; border: 1.5px solid #f3f4f6;
  border-radius: 10px; padding: 20px; margin-top: 4px;
}
.ap-password-section-title {
  font-size: 12px; font-weight: 700; color: #374151;
  text-transform: uppercase; letter-spacing: .7px;
  margin-bottom: 16px;
  display: flex; align-items: center; gap: 7px;
}

/* ════ AUTH ════ */
.ap-auth {
  padding: 48px 16px 64px;
  background: rgb(243, 250, 242);
  font-family: 'Plus Jakarta Sans', sans-serif;
  min-height: 100%;
}
.ap-auth-inner {
  max-width: 980px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 420px;
  gap: 32px;
  align-items: start;
}
.ap-auth-info { padding: 40px 0 0; }
.ap-auth-info-badge {
  display: inline-flex; align-items: center; gap: 6px;
  background: #f0fdf4; border: 1px solid #bbf7d0;
  color: #15803d; font-size: 11px; font-weight: 700;
  padding: 5px 12px; border-radius: 20px;
  letter-spacing: .3px; text-transform: uppercase;
  margin-bottom: 20px;
}
.ap-auth-info h2 {
  font-size: 32px; font-weight: 800; color: #111827;
  line-height: 1.2; letter-spacing: -.7px; margin-bottom: 14px;
}
.ap-auth-info h2 span { color: #15803d; }
.ap-auth-info p {
  font-size: 15px; color: #6b7280; line-height: 1.7;
  max-width: 380px; margin-bottom: 36px;
}
.ap-auth-perks { display: flex; flex-direction: column; gap: 12px; }
.ap-auth-perk { display: flex; align-items: center; gap: 12px; }
.ap-auth-perk-icon {
  width: 36px; height: 36px; border-radius: 9px;
  display: flex; align-items: center; justify-content: center;
  font-size: 15px; flex-shrink: 0;
}
.ap-auth-perk-icon.g { background: #f0fdf4; color: #16a34a; }
.ap-auth-perk-icon.b { background: #eff6ff; color: #2563eb; }
.ap-auth-perk-icon.a { background: #fffbeb; color: #d97706; }
.ap-auth-perk-icon.r { background: #fef2f2; color: #dc2626; }
.ap-auth-perk-text strong { display: block; font-size: 13px; font-weight: 700; color: #111827; margin-bottom: 1px; }
.ap-auth-perk-text span  { font-size: 12px; color: #9ca3af; }
.ap-auth-card {
  background: #fff; border: 1px solid #eaecf0; border-radius: 16px;
  overflow: hidden; box-shadow: 0 2px 16px rgba(0,0,0,0.06);
  position: sticky; top: 24px;
}
.ap-auth-card-hd { padding: 26px 28px 22px; border-bottom: 1px solid #f3f4f6; }
.ap-tabs {
  display: flex; background: #f3f4f6; border-radius: 8px;
  padding: 3px; margin-bottom: 20px;
}
.ap-tab {
  flex: 1; padding: 8px; font-size: 13px; font-weight: 600;
  border: none; border-radius: 6px; cursor: pointer;
  font-family: 'Plus Jakarta Sans', sans-serif; transition: all .15s;
}
.ap-tab.on  { background: #fff; color: #111827; box-shadow: 0 1px 4px rgba(0,0,0,0.08); }
.ap-tab.off { background: transparent; color: #9ca3af; }
.ap-tab.off:hover { color: #374151; }
.ap-auth-heading { font-size: 19px; font-weight: 800; color: #111827; letter-spacing: -.4px; margin-bottom: 3px; }
.ap-auth-sub { font-size: 13px; color: #9ca3af; }
.ap-auth-card-bd { padding: 22px 28px 28px; }
.ap-field { margin-bottom: 15px; }
.ap-label { display: block; font-size: 12px; font-weight: 600; color: #374151; margin-bottom: 6px; }
.ap-input {
  width: 100%; padding: 11px 14px;
  font-size: 14px; font-family: 'Plus Jakarta Sans', sans-serif;
  background: #fff; border: 1.5px solid #e5e7eb;
  border-radius: 9px; color: #111827; outline: none;
  transition: border-color .18s;
}
.ap-input:focus { border-color: #111827; background: #fafafa; }
.ap-input::placeholder { color: #d1d5db; }
.ap-input-wrap { position: relative; }
.ap-input-wrap .ap-input { padding-right: 42px; }
.ap-eye {
  position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
  background: none; border: none; cursor: pointer;
  color: #9ca3af; font-size: 16px; padding: 0;
}
.ap-eye:hover { color: #374151; }
.ap-hint { font-size: 11px; color: #9ca3af; margin-top: 5px; }
.ap-submit {
  width: 100%; padding: 13px;
  font-size: 14px; font-weight: 700; font-family: 'Plus Jakarta Sans', sans-serif;
  background: #111827; color: #fff; border: none; border-radius: 9px;
  cursor: pointer; transition: opacity .15s, transform .12s;
  margin-bottom: 9px; letter-spacing: -.1px;
}
.ap-submit:hover:not(:disabled) { opacity: .88; transform: translateY(-1px); }
.ap-submit:disabled { opacity: .4; cursor: default; transform: none; }
.ap-back {
  width: 100%; padding: 11px;
  font-size: 13px; font-weight: 600; font-family: 'Plus Jakarta Sans', sans-serif;
  background: #f9fafb; color: #374151;
  border: 1.5px solid #e5e7eb; border-radius: 9px; cursor: pointer;
  transition: all .15s;
}
.ap-back:hover:not(:disabled) { background: #f3f4f6; }
.ap-otp-wrap {
  background: #f9fafb; border: 1.5px solid #e5e7eb;
  border-radius: 10px; padding: 18px 16px; text-align: center; margin-bottom: 12px;
}
.ap-otp-input {
  width: 100%; font-size: 32px; font-weight: 700; font-family: 'Fira Code', monospace;
  letter-spacing: 20px; text-align: center; background: transparent;
  border: none; outline: none; color: #111827;
}
.ap-otp-input::placeholder { color: #e5e7eb; letter-spacing: 14px; }
.ap-otp-info { font-size: 12px; color: #9ca3af; margin-top: 6px; }
.ap-resend { text-align: center; font-size: 12px; color: #9ca3af; margin: 12px 0 18px; }
.ap-resend-btn {
  color: #111827; font-weight: 700;
  background: none; border: none; cursor: pointer;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 12px;
}
.ap-resend-btn:hover { text-decoration: underline; }
.ap-otp-notice {
  display: flex; align-items: flex-start; gap: 9px;
  background: #eff6ff; border: 1px solid #bfdbfe;
  border-radius: 9px; padding: 11px 13px; margin-bottom: 16px;
  font-size: 12px; color: #1d4ed8; font-weight: 500;
}
.ap-divider {
  display: flex; align-items: center; gap: 12px;
  margin: 18px 0; color: #e5e7eb; font-size: 12px; color: #d1d5db;
}
.ap-divider::before, .ap-divider::after { content: ''; flex: 1; height: 1px; background: #f3f4f6; }
.ap-forgot { text-align: right; margin-bottom: 14px; }
.ap-forgot a { font-size: 12px; color: #6b7280; font-weight: 600; text-decoration: none; }
.ap-forgot a:hover { color: #111827; }
.ap-switch { text-align: center; font-size: 13px; color: #6b7280; margin-top: 18px; padding-top: 18px; border-top: 1px solid #f3f4f6; }
.ap-switch-btn {
  color: #111827; font-weight: 700;
  background: none; border: none; cursor: pointer;
  font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px;
  text-decoration: underline; text-underline-offset: 2px;
}

@media (max-width: 640px) {
  .ap-welcome {
    padding: 22px 20px;
    gap: 14px;
  }

  .ap-welcome-name {
    font-size: clamp(17px, 5vw, 22px);
  }

  .ap-welcome-sub {
    font-size: 12px;
  }

  .ap-welcome-badge {
    max-width: 42%;
  }

  .ap-welcome-badge-val {
    font-size: clamp(13px, 4vw, 18px);
  }
}

@media (max-width: 460px) {
  .ap-welcome {
    flex-wrap: wrap;
    align-items: stretch;
  }

  .ap-welcome-badge {
    width: 100%;
    max-width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }

  .ap-welcome-badge-val {
    max-width: 65%;
    font-size: clamp(13px, 5vw, 17px);
  }

  .ap-welcome-badge-lbl {
    font-size: 10px;
  }
}

@media (max-width: 360px) {
  .ap-welcome {
    padding: 18px 16px;
  }

  .ap-welcome-badge-val {
    max-width: 60%;
    font-size: 13px;
  }
}

@media(max-width:900px){
  .ap-auth-inner { grid-template-columns: 1fr; }
  .ap-auth-info { display: none; }
  .ap-dash { grid-template-columns:1fr; }
  .ap-side { display:none; }
  .ap-main { margin-left:0; }
  .ap-stats { grid-template-columns:1fr; }
  .ap-settings-grid { grid-template-columns:1fr; }
}

@media(max-width:420px){
  .ap-side-nav {
    grid-template-columns: 1fr;
  }
}
`;

export function useInjectCSS() {
  // Call this hook inside Account.jsx (root component only)
  // import { useEffect } from "react";
  // import { CSS } from "./AccountCSS";
  // useEffect(() => {
  //   if (document.getElementById("ap-css")) return;
  //   const el = document.createElement("style");
  //   el.id = "ap-css";
  //   el.textContent = CSS;
  //   document.head.appendChild(el);
  // }, []);
}